import api from './api';
import {
  LeaveBalance,
  LeaveRequest,
  ApplyLeaveData,
  LeaveStatus,
  ApiResponse,
} from '../types';

export const leaveService = {
  async applyLeave(data: ApplyLeaveData): Promise<LeaveRequest> {
    const response = await api.post<ApiResponse<LeaveRequest>>('/leave/apply', data);
    return response.data.data!;
  },

  async getMyLeaveBalance(month?: number, year?: number): Promise<LeaveBalance> {
    const queryParams = new URLSearchParams();
    if (month) queryParams.append('month', String(month));
    if (year) queryParams.append('year', String(year));
    
    const response = await api.get<ApiResponse<LeaveBalance>>(
      `/leave/balance?${queryParams}`
    );
    return response.data.data!;
  },

  async getEmployeeLeaveBalance(
    employeeId: number,
    month?: number,
    year?: number
  ): Promise<LeaveBalance> {
    const queryParams = new URLSearchParams();
    if (month) queryParams.append('month', String(month));
    if (year) queryParams.append('year', String(year));
    
    const response = await api.get<ApiResponse<LeaveBalance>>(
      `/leave/balance/${employeeId}?${queryParams}`
    );
    return response.data.data!;
  },

  async getMyLeaveRequests(status?: LeaveStatus): Promise<LeaveRequest[]> {
    const queryParams = status ? `?status=${status}` : '';
    const response = await api.get<ApiResponse<LeaveRequest[]>>(
      `/leave/requests${queryParams}`
    );
    return response.data.data!;
  },

  async getAllLeaveRequests(status?: LeaveStatus): Promise<LeaveRequest[]> {
    const queryParams = status ? `?status=${status}` : '';
    const response = await api.get<ApiResponse<LeaveRequest[]>>(
      `/leave/requests/all${queryParams}`
    );
    return response.data.data!;
  },

  async approveLeaveRequest(
    id: number,
    status: 'APPROVED' | 'REJECTED',
    rejectedReason?: string
  ): Promise<LeaveRequest> {
    const response = await api.put<ApiResponse<LeaveRequest>>(
      `/leave/requests/${id}/approve`,
      { status, rejectedReason }
    );
    return response.data.data!;
  },

  async cancelLeaveRequest(id: number): Promise<LeaveRequest> {
    const response = await api.delete<ApiResponse<LeaveRequest>>(
      `/leave/requests/${id}`
    );
    return response.data.data!;
  },

  async accrueMonthlyLeave(month: number, year: number): Promise<void> {
    await api.post('/leave/accrue', { month, year });
  },
};
